import React from "react";
import style from "./index.module.scss";
import { ExerciseQuestionItem } from "../../../../../service/exercise";
import { htmlToPlain, replaceImgTag } from "../../../../../utils/common";

export default function ExerciseListItem({
    data,
    index
}: {
    data: ExerciseQuestionItem;
    index: number;
}) {
    return (
        <div className={style.root}>
            <div className={style.title}>
                {index}.{" "}
                <span className={style.info}>
                    <span>（</span>
                    <span className={style.queTypeName}>
                        {data.queTypeName}
                    </span>
                    <span>，{data.score ? data.score : 0}分）</span>
                </span>
            </div>

            <div className={style.content}>
                {htmlToPlain(data.contentText, replaceImgTag)}
            </div>
        </div>
    );
}
